import React from 'react';
import PropTypes from 'prop-types';
import FinancialPlanHeader from '../../FinancialPlanHeaderView';
import AssumptionsSectionView from '../../Components/AssumptionsTable';
import GeneralAssumptionsView from '../../GeneralAssumptions';
import Explanations from '../../Explanations/ExplanationsContainer';

const InsuranceAssumptionsView = (props) => {
  const {
    clientId,
    isPrint,
    assumptionsValuesList,
    showCalibration,
    assumptionsLabelMap,
  } = props;

  return (
    <div>
      <div
        className={`NewFinancialPlan_header${
          !showCalibration ? ' hide-calibration-button' : ''
        }`}
      >
        <FinancialPlanHeader
          {...props}
          clientId={clientId}
          hideOldDescription={false}
          printTitle="Insurance Assumptions"
          hideTrackIndicator={isPrint}
        />
      </div>
      <section className="calibration" />
      {!isPrint && <Explanations clientId={clientId} />}
      <div className="assumptions-container">
        <AssumptionsSectionView
          title="Insurance Goal Assumptions"
          valuesList={assumptionsValuesList}
          labelList={assumptionsLabelMap}
        />
        <br />
        {!isPrint && <GeneralAssumptionsView clientId={clientId} />}
      </div>
    </div>
  );
};

InsuranceAssumptionsView.defaultProps = {
  isPrint: false,
};

InsuranceAssumptionsView.propTypes = {
  clientId: PropTypes.string.isRequired,
  isPrint: PropTypes.bool,
  assumptionsValuesList: PropTypes.shape({}).isRequired,
  showCalibration: PropTypes.bool.isRequired,
  assumptionsLabelMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default InsuranceAssumptionsView;
